import React, {Suspense} from 'react';
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import useTitleAndDescription from "../../../common/hooks/useTitleAndDescription";
import {Footer, Header, Loading} from "../../common";
import {ErrorBoundary} from "react-error-boundary";
import CenterContentBox from "../../Champions/ContentWrapper";
import BottomStickAd from "../../ad/BottomStickAd";
import GoseGuContent from "./GoseGuContent";

const Wrapper = styled.div`
`;

const ContentWrapper = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;


function Fallback({error, resetErrorBoundary}) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.

    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{error.message}</pre>
        </div>
    );
}

const Gosegu = () => {
    const {t} = useTranslation();
    useTitleAndDescription({
        title: '쇠구컵 2026 | Deeplol.gg',
        description: '이세계 아이돌 고세구 주최 쇠구컵 2026과 딥롤의 공식 협업을 통해 저티어 대회만의 매력을 극대화한 콘텐츠를 제공합니다.',
    })
    return (
        <Wrapper>
            <Header/>
            <ContentWrapper>
                <ErrorBoundary FallbackComponent={Fallback}>
                    <CenterContentBox disableSponsor={true}>
                        <Suspense fallback={<Loading/>}>
                            <GoseGuContent/>
                        </Suspense>
                    </CenterContentBox>
                </ErrorBoundary>
            </ContentWrapper>
            <Footer/>
            <BottomStickAd/>
        </Wrapper>
    );
}

export default Gosegu;